import * as yup from 'yup';
import { EIsoCountryCodes } from '../../../../common/iso-country-codes';
import {
  EIdentityDocumentType,
  EPassengerTitle,
} from '../../../../common/types';
import {
  isPassengerBirthDateValid,
  isPassengerIdendityDocumentExpirationDateValid,
} from '../../../../hooks/usePassengersManagement/utils';
import { isEmailValid } from '../../../PassengersInfo/View/Form/schema';

export const passengerFormValidationErrorMessageId = {
  GENERIC: 'passengerForm.validationError',
  INVALID_DATE: 'passengerForm.validationError.date',
  INVALID_EMAIL: 'passengerForm.validationError.email',
};

const passengerFormIdentityDocumentSchema = yup.array().of(
  yup.object({
    countryCode: yup.string().oneOf(Object.values(EIsoCountryCodes)).required(),
    expirationDate: yup
      .string()
      .required()
      .test(
        'Invalid Date',
        passengerFormValidationErrorMessageId.INVALID_DATE,
        (value) => isPassengerIdendityDocumentExpirationDateValid(value),
      ),
    documentIdentifier: yup.string().required(),
    type: yup.string().oneOf(Object.values(EIdentityDocumentType)).required(),
  }),
);

const passengerFormDiscountCardSchema = yup
  .array()
  .required()
  .of(
    yup.object({
      code: yup.string().required(),
      discountCardId: yup.string().required(),
      expirationDate: yup
        .string()
        .optional()
        .test(
          'Invalid Date',
          passengerFormValidationErrorMessageId.INVALID_DATE,
          (value) =>
            value
              ? isPassengerIdendityDocumentExpirationDateValid(value)
              : true,
        ),
    }),
  );

export const passengerFormSchema = yup.object({
  birthdate: yup
    .string()
    .required()
    .test(
      'Invalid Date',
      passengerFormValidationErrorMessageId.INVALID_DATE,
      (value) => isPassengerBirthDateValid(value),
    ),
  discountCards: passengerFormDiscountCardSchema.required(),
  mail: yup
    .string()
    .email()
    .optional()
    .test(
      'Invalid Email format',
      passengerFormValidationErrorMessageId.INVALID_EMAIL,
      (value) => (value ? isEmailValid(value) : true),
    ),
  firstName: yup.string().required(),
  identityDocuments: passengerFormIdentityDocumentSchema.required(),
  lastName: yup.string().required(),
  title: yup.string().required().oneOf(Object.values(EPassengerTitle)),
});

export type PassengerFormData = yup.InferType<typeof passengerFormSchema>;
